<template>
  <div>
    <Potential
      v-if="isCustChange"
      :formData="formData"
      :custCode="custCode"
    ></Potential>
    <InfoChange
      v-if="isInfoChange"
      :formData="formData"
      :custCode="custCode"
    ></InfoChange>
    <OrderChange
      v-if="isOrderChange"
      :formData="formData"
      :custCode="custCode"
    ></OrderChange>
    <BankChange
      v-if="isBankChange"
      :formData="formData"
      :custCode="custCode"
    ></BankChange>

    <CustCard :title="$l('form_label_applicant_information') || '申请人信息'">
      <el-form size="mini" label-position="top">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_submit_applicant') || '提交申请人'"
            >
              <el-input v-model="formData.createByName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_submit_time') || '提交时间'">
              <el-input v-model="formData.createDate" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </CustCard>
    <CustCard
      :title="$l('form_label_supervisor_approval') || '部门主管审批'"
      v-if="isManager || isCeo || isOver"
    >
      <el-form size="mini" label-position="top">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_approval') || '审批人'">
              <el-input v-model="formData.managerApprovalByName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_approval_time') || '审批时间'">
              <el-input v-model="formData.managerApprovalDate" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="isManager && !disabled">
            <el-form-item
              :label="$l('form_label_approval_results') || '审批结果'"
            >
              <el-button
                @click="reject"
                type="danger"
                size="mini"
                style="width: 120px"
              >
                {{ $l('button_label_no_pass') || '不通过' }}
              </el-button>
              <el-button
                type="success"
                size="mini"
                @click="approval()"
                style="width: 120px"
              >
                {{ $l('button_label_pass') || '通过' }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_approval_opinions') || '审批意见'"
            >
              <el-input
                v-model="formData.managerApprovalRemark"
                :placeholder="
                  $l('ple_label_approval_opinions') || '请输入审批意见'
                "
                type="textarea"
                :rows="5"
                :maxlength="500"
                show-word-limit
                clearable
                :disabled="!isManager || disabled"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </CustCard>
    <CustCard
      :title="$l('form_label_ceo_approval') || 'CEO审批'"
      v-if="isCeo || isOver"
    >
      <el-form size="mini" label-position="top">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_approval') || '审批人'">
              <el-input v-model="formData.ceoApprovalByName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_approval_time') || '审批时间'">
              <el-input v-model="formData.ceoApprovalDate" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_approval_results') || '审批结果'"
              v-if="isCeo && !disabled"
            >
              <el-button
                @click="reject"
                type="danger"
                size="mini"
                style="width: 120px"
              >
                {{ $l('button_label_no_pass') || '不通过' }}
              </el-button>
              <el-button
                type="success"
                size="mini"
                @click="approval()"
                style="width: 120px"
              >
                {{ $l('button_label_pass') || '通过' }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_approval_opinions') || '审批意见'"
            >
              <el-input
                v-model="formData.ceoApprovalRemark"
                :placeholder="
                  $l('ple_label_approval_opinions') || '请输入审批意见'
                "
                type="textarea"
                :rows="5"
                :maxlength="500"
                show-word-limit
                clearable
                :disabled="!isCeo || disabled"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </CustCard>
    <!-- <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ '是否进行审批' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="reject" type="danger" size="mini">
          {{ '不通过' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="success"
          size="mini"
          @click="approval()"
        >
          {{ '通过' }}
        </el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import Potential from '../potential/index'
import InfoChange from '../info-change'
import OrderChange from '../order-change'
import BankChange from '../bank-change'
import CustCard from '../cust-card'

export default {
  mixins: [EditLoading],
  components: { Potential, CustCard, InfoChange, OrderChange, BankChange },

  props: {
    disabled: { type: Boolean, default: false },
    custApprovalRequestCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    custApprovalRequestType: { type: String, default: '' },
    custApprovalNode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    isCustChange() {
      return ['F', 'P'].includes(this.custApprovalRequestType)
    },
    isInfoChange() {
      return ['I'].includes(this.custApprovalRequestType)
    },
    isOrderChange() {
      return ['O'].includes(this.custApprovalRequestType)
    },
    isBankChange() {
      return ['B'].includes(this.custApprovalRequestType)
    },
    isManager() {
      return ['1'].includes(this.custApprovalNode)
    },
    isCeo() {
      return ['2'].includes(this.custApprovalNode)
    },
    isOver() {
      return ['20'].includes(this.custApprovalNode)
    },
  },
  methods: {
    async getData() {
      if (!this.custApprovalRequestCode) return
      const res = await this.$api
        .customerApprovalRequsetDetailApi({
          custApprovalRequestCode: this.custApprovalRequestCode,
        })
        .catch(() => null)
      if (!res) return
      const data = res.body
      this.formData = data
    },
    async approval() {
      if (this.loadingOpen()) return
      const res = await this.$api
        .customerApprovalRequsetApprovalApi({
          custApprovalRequestCode: this.custApprovalRequestCode,
          ceoApprovalRemark: this.formData.ceoApprovalRemark,
          managerApprovalRemark: this.formData.managerApprovalRemark,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_failed_passed') || '通过失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_successfully_passed') || '通过成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    async reject() {
      const { ceoApprovalRemark, managerApprovalRemark } = this.formData
      if (this.isManager && !managerApprovalRemark) {
        this.$message.warning(
          this.$l('tips_fill_in_approval_opinion_the_department') ||
            '请填写部门主管审批意见!'
        )
        return
      }
      if (this.isCeo && !ceoApprovalRemark) {
        this.$message.warning(
          this.$l('tips_fill_in_approval_opinion_the_ceo') ||
            '请填写CEO审批意见!'
        )
        return
      }

      this.$confirm(
        this.$l('tips_want_to_reject') || '是否驳回该请求',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .customerApprovalRequsetRejectApi({
            custApprovalRequestCode: this.custApprovalRequestCode,
            ceoApprovalRemark,
            managerApprovalRemark,
          })
          .then(() => {
            this.$message.success(
              this.$l('tips_successfully_reject') || '驳回成功!'
            )
            this.close()
            this.$emit('reload')
          })
      })
    },
    cancel() {
      this.close()
      // if (this.disabled) return this.close()
      // this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 15px;
  }

  .ql-editor,
  .el-input .el-input__inner[readonly='readonly'] {
    background-color: #f9f9f9;
    border: none !important;
  }

  .header-card {
    margin-bottom: 10px;
    .el-card__body {
      padding-bottom: 0;
    }
  }
}
</style>
